import { z } from 'zod'
import { baseSchema } from './base'

export const linkSchema = baseSchema.extend({
  type: z.literal('link'),
  text: z.string().optional(),
  href: z.string(),
  target: z.enum(['_blank', '_self', '_parent', '_top']).default('_blank'),
  params: z.record(z.string(), z.any()).optional().describe('跳转时携带的查询参数'),
})

export type LinkSchema = z.infer<typeof linkSchema>
